import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { HorizontalMenuItems } from './menu-items/horizontal-menu-items';

import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective
} from './accordion';
import { FormCatalogComponent } from './form-catalog/form-catalog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DemoMaterialModule } from '../demo-material-module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DynamicFormComponent } from './form-catalog/dynamic-components/dynamic-form/dynamic-form.component';
import { DynamicErrorComponent } from './form-catalog/dynamic-components/dynamic-form/dynamic-error/dynamic-error.component';
import { DynamicCheckboxComponent } from './form-catalog/dynamic-components/dynamic-fields/dynamic-checkbox/dynamic-checkbox.component';
import { DynamicInputComponent } from './form-catalog/dynamic-components/dynamic-fields/dynamic-input/dynamic-input.component';
import { DynamicRadioComponent } from './form-catalog/dynamic-components/dynamic-fields/dynamic-radio/dynamic-radio.component';
import { DynamicSelectComponent } from './form-catalog/dynamic-components/dynamic-fields/dynamic-select/dynamic-select.component';
import { DynamicFieldsComponent } from './form-catalog/dynamic-components/dynamic-fields/dynamic-fields.component';
import { CommonModule } from '@angular/common';
import { DynamicFileComponent } from './form-catalog/dynamic-components/dynamic-fields/dynamic-file/dynamic-file.component';
import { NgxMatFileInputModule } from '@angular-material-components/file-input';
import { DynamicHiddenComponent } from './form-catalog/dynamic-components/dynamic-fields/dynamic-hidden/dynamic-hidden.component';
import { DynamicDateComponent } from './form-catalog/dynamic-components/dynamic-fields/dynamic-date/dynamic-date.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DynamicSlideToggleComponent } from './form-catalog/dynamic-components/dynamic-fields/dynamic-slide-toggle/dynamic-slide-toggle.component';
import { CatalogsModule } from '../catalogs/catalogs.module';
import { ClientFormComponent } from '../catalogs/clients/client-form/client-form.component';
import { FilesDropUploaderComponent } from './components/files-drop-uploader/files-drop-uploader.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import {FirmaUploadComponent} from './components/firma-upload/firma-upload.component'

@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    FormCatalogComponent,
    DynamicFormComponent,
    DynamicErrorComponent,
    DynamicCheckboxComponent,
    DynamicInputComponent,
    DynamicRadioComponent,
    DynamicSelectComponent,
    DynamicFieldsComponent,
    DynamicFileComponent,
    DynamicHiddenComponent,
    DynamicDateComponent,
    ConfirmDialogComponent,
    UploadFileComponent,
    DynamicSlideToggleComponent,
    FilesDropUploaderComponent,
    FirmaUploadComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DemoMaterialModule,
    FlexLayoutModule,
    CommonModule,
    NgxMatFileInputModule,
    DropzoneModule,
    NgxDropzoneModule
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    FilesDropUploaderComponent,
    FirmaUploadComponent
  ],
  providers: [MenuItems, HorizontalMenuItems]
})
export class SharedModule { }
